module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_close-c801d682da5a739cf6358401aae55e53.png";